var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccelerated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00065 22.0004C4.00065 23.6804 3.33398 28.6671 3.33398 28.6671C3.33398 28.6671 8.32065 28.0004 10.0007 26.0004C10.9473 24.8804 10.934 23.1604 9.88065 22.1204C9.36239 21.6258 8.67971 21.3399 7.96362 21.3178C7.24753 21.2956 6.54849 21.5387 6.00065 22.0004Z",
    stroke: "#142454",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 19.9997L12 15.9997C12.7095 14.1589 13.6029 12.3944 14.6667 10.733C16.2202 8.249 18.3835 6.20374 20.9507 4.7918C23.5178 3.37986 26.4036 2.64817 29.3333 2.66635C29.3333 6.29301 28.2933 12.6663 21.3333 17.333C19.6492 18.398 17.8625 19.2913 16 19.9997Z",
    stroke: "#142454",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0007 15.9997H5.33398C5.33398 15.9997 6.06732 11.9597 8.00065 10.6664C10.1607 9.22637 14.6673 10.6664 14.6673 10.6664",
    stroke: "#142454",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 19.9997V26.6663C16 26.6663 20.04 25.933 21.3333 23.9997C22.7733 21.8397 21.3333 17.333 21.3333 17.333",
    stroke: "#142454",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccelerated);
export default __webpack_public_path__ + "static/media/Accelerated.68870442c3aa13beab45e764a7c6dfa7.svg";
export { ForwardRef as ReactComponent };